import axiosIns from '@/libs/axios'

const ROOT_URL = '/profit-strategies'

export default {
  namespaced: true,
  state: {
    dataList: [],
    metaData: {
      total: 0, page: 1, limit: 50, totalPages: 0,
    },
    detail: null,
    applyResult: null,
    dataSave: { message: null, status: null },
  },
  getters: {
    dataList: s => s.dataList,
    metaData: s => s.metaData,
    detail: s => s.detail,
    applyResult: s => s.applyResult,
    dataSaveStatus: s => s.dataSave,
  },
  mutations: {
    SET_DATA_LIST(state, data) { state.dataList = data },
    SET_META_DATA(state, data) { state.metaData = data },
    SET_DETAIL(state, data) { state.detail = data },
    SET_APPLY_RESULT(state, data) { state.applyResult = data },
    SET_DATA_SAVE(state, data) { state.dataSave = data },
  },
  actions: {
    getDataList({ commit }, params) {
      return axiosIns.post(ROOT_URL, params || {})
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_META_DATA', response.data.meta || {
            total: 0, page: 1, limit: 50, totalPages: 0,
          })
          return response.data.data
        })
        .catch(error => {
          console.error(error)
          commit('SET_DATA_SAVE', { status: false, message: 'Kazanç stratejileri alınamadı.' })
          return []
        })
    },
    create({ commit, dispatch }, body) {
      return axiosIns.post(`${ROOT_URL}/create`, body)
        .then(response => {
          commit('SET_DATA_SAVE', { status: true, message: 'Kazanç stratejisi oluşturuldu.' })
          dispatch('getDataList', {})
          return response.data.data
        })
        .catch(error => {
          console.error(error)
          const msg = error?.response?.data?.message || 'Oluşturma başarısız.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
          throw error
        })
    },
    update({ commit, dispatch }, { id, body }) {
      return axiosIns.patch(`${ROOT_URL}/${id}`, body)
        .then(response => {
          commit('SET_DATA_SAVE', { status: true, message: 'Kazanç stratejisi güncellendi.' })
          return dispatch('getDataList', {}).then(() => response.data.data)
        })
        .catch(error => {
          console.error(error)
          const msg = error?.response?.data?.message || 'Güncelleme başarısız.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
          throw error
        })
    },
    remove({ commit, dispatch }, id) {
      return axiosIns.delete(`${ROOT_URL}/${id}`)
        .then(() => {
          commit('SET_DATA_SAVE', { status: true, message: 'Kazanç stratejisi silindi.' })
          dispatch('getDataList', {})
        })
        .catch(error => {
          console.error(error)
          const msg = error?.response?.data?.message || 'Silme başarısız.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
        })
    },
    apply({ commit }, { id, body }) {
      commit('SET_APPLY_RESULT', null)
      return axiosIns.post(`${ROOT_URL}/${id}/apply`, body || {})
        .then(response => {
          commit('SET_APPLY_RESULT', response.data.data)
          commit('SET_DATA_SAVE', { status: true, message: 'Kazanç stratejisi uygulandı.' })
          return response.data.data
        })
        .catch(error => {
          console.error(error)
          const msg = error?.response?.data?.message || 'Strateji uygulanamadı.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
          throw error
        })
    },
    profileCheck({ commit }, body) {
      return axiosIns.post(`${ROOT_URL}/profile-check`, body || {})
        .then(response => response.data.data)
        .catch(error => {
          console.error(error)
          const msg = error?.response?.data?.message || 'Profil kontrolü çalıştırılamadı.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
          throw error
        })
    },
    pnlHealth({ commit }, body) {
      return axiosIns.post(`${ROOT_URL}/pnl-health`, body || {})
        .then(response => response.data.data)
        .catch(error => {
          console.error(error)
          const msg = error?.response?.data?.message || 'K/Z sağlık paneli hesaplanamadı.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
          throw error
        })
    },
  },
}
